import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const Contract = createIcon({
  displayName: "Contract",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75358 3.04644C3.55832 2.85118 3.24173 2.85118 3.04647 3.04644C2.85121 3.2417 2.85121 3.55829 3.04647 3.75355L8.77292 9.47999H3.40002C3.12388 9.47999 2.90002 9.70385 2.90002 9.97999C2.90002 10.2561 3.12388 10.48 3.40002 10.48H9.98002C10.2562 10.48 10.48 10.2561 10.48 9.97999V3.39999C10.48 3.12385 10.2562 2.89999 9.98002 2.89999C9.70388 2.89999 9.48002 3.12385 9.48002 3.39999V8.77289L3.75358 3.04644ZM15.2271 14.52H20.6C20.8762 14.52 21.1 14.2961 21.1 14.02C21.1 13.7438 20.8762 13.52 20.6 13.52H14.02C13.7439 13.52 13.52 13.7438 13.52 14.02V20.6C13.52 20.8761 13.7439 21.1 14.02 21.1C14.2962 21.1 14.52 20.8761 14.52 20.6V15.2272L20.2464 20.9536C20.4417 21.1488 20.7583 21.1488 20.9535 20.9536C21.1488 20.7583 21.1488 20.4417 20.9535 20.2465L15.2271 14.52Z"
    />
  )
});
